import Mapper from './Mapper';
import { PriceAnyResponseDTO } from 'typings/dto/price';

export default class PriceServiceProviderMapper extends Mapper<Price.SP, PriceAnyResponseDTO.SP> {
  constructor() {
    super(
      {
        currency: 'currency',
        owner: 'owner',
        region: 'region',
        serviceItem: 'service',
        attributes: 'attributes',
        catalogPrice: 'clientValue',
        clientPrice: 'clientPrice',
        type: 'type',
        promotion: 'promotion',
        productPrice: 'productPrice',
      }
    );
  }

  public responseDTOToModel(dto: PriceAnyResponseDTO.SP): Price.SP {
    return {
      ...(this.getOuterMappers().priceAny.responseDTOToModel(dto) as Price.SP),
    };
  }

  public responseDTOToModelIdAndNamesOnly = (dto: PriceAnyResponseDTO.SP): Price.SP => {
    return this.responseDTOToModel(dto);
  };
}
